'use strict';

var assetColors = require('../../../../../../../../../../_virtual/assetColors.cjs');

var hasRequiredAssetColors;

function requireAssetColors () {
	if (hasRequiredAssetColors) return assetColors.__exports;
	hasRequiredAssetColors = 1;

	var ASSET_COLORS = /*#__PURE__*/ function(ASSET_COLORS) {
	    ASSET_COLORS["grey"] = "grey";
	    ASSET_COLORS["green"] = "green";
	    ASSET_COLORS["blue"] = "blue";
	    ASSET_COLORS["red"] = "red";
	    ASSET_COLORS["orange"] = "orange";
	    ASSET_COLORS["purple"] = "purple";
	    ASSET_COLORS["sand"] = "sand";
	    return ASSET_COLORS;
	}({});

	assetColors.__exports.ASSET_COLORS = ASSET_COLORS;
	
	return assetColors.__exports;
}

exports.__require = requireAssetColors;
//# sourceMappingURL=assetColors.cjs.map
